import axios from 'axios';
import { API_PATH, FINANCING_API_PATH } from '~/common/utils/constants';

export const getUserPreviousOrders = () => axios.get(`${API_PATH}/previous-orders`);

export const getUserOrders = () => axios.get(`${API_PATH}/user-orders`);

export const getReferralInfo = () => axios.get(`${API_PATH}/referral-info/v2`);

export const fetchESignSummary = (rn, docType, packetType) =>
  axios.get(
    `${FINANCING_API_PATH}/cosign-summary?rn=${rn}&docType=${docType}&packetType=${packetType}`
  );

export const validateCoSignDetails = (data) =>
  axios.post(`${FINANCING_API_PATH}/cosign-validate-details`, data);

export const removeDriverAccess = (data) => axios.post(`${API_PATH}/remove-driver-access`, data);
